export default "__VITE_ASSET__4uIineiJ__"